// extracted by mini-css-extract-plugin
export var container = "_5o-0";
export var infoButton = "_5o-1";
export var label = "_5o-3";
export var labelExpanded = "_5o-4";
export var price = "_5o-5";
export var priceExpanded = "_5o-6";
export var title = "_5o-2";